import { Map } from 'immutable';
import { connect } from '../../../../react-redux';
import ItemOverride from './presenter';
import makeEditable from '../../../shared/functionality/makeEditable';
import * as modificationActions from '../../../../actions/modifications';
import { occludeQuizEntries } from '../../../../actions/ui';
import { addError, screenreaderNotification } from '../../../../actions/alerts';
import { interactionFileUpload, setOneAtATimeType } from '../../../../../building/api/quizzes';
import { featureOn } from '../../../../util/featureCheck';
import { getActiveQuizId, isActiveQuizWorkingInstanceOneQuestionAtATime } from '../../../../selectors/quizzes';
function mapStateToProps(state, props) {
  var errorsShowing = state.get('errorsShowing', Map());
  var errorsAreShowing = errorsShowing.get(props.guid);
  return {
    entry: props.quizEntry.getWorkingInstance().getItem(),
    errorsAreShowing: errorsAreShowing,
    oneQuestionAtATime: isActiveQuizWorkingInstanceOneQuestionAtATime(state),
    partialDeepScoringEnabled: featureOn('partial_deep_scoring'),
    partialScoringEnabled: featureOn('partial_scoring'),
    quizId: getActiveQuizId(state)
  };
}
var mapDispatchToProps = {
  addError: addError,
  changeQuizEntryProperties: modificationActions.changeQuizEntryProperties,
  interactionFileUpload: interactionFileUpload,
  occludeQuizEntries: occludeQuizEntries,
  screenreaderNotification: screenreaderNotification,
  setOneQuestionAtATime: setOneAtATimeType
};
export default makeEditable(connect(mapStateToProps, mapDispatchToProps)(ItemOverride));